module.exports = __webpack_public_path__ + "static/media/treasure-chest.e2ed663e.svg";